import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getMedicineTypeSlice = createAsyncThunk(
  "medicineType/getMedicineType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/medicineType/getAllMedicineTypes", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getMedicineTypeByIdSlice = createAsyncThunk(
  "medicineType/getMedicineTypeById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/medicineType/getMedicineTypeById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);


const initialState = {
  loading: false,
  medicineTypes: [],
  medicineTypeInfo: [],
  searchMedicineTypeErrorMessage: null,
};

const medicineTypeSlice = createSlice({
  name: "medicineType",
  initialState,
  reducers: {
    resetSearchMedicineTypeMessage: (state) => {
      state.searchMedicineTypeErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMedicineTypeSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMedicineTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchMedicineTypeErrorMessage = action?.payload?.result?.message;
        }
        state.medicineTypes = action?.payload?.result?.list;
      })
      .addCase(getMedicineTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchMedicineTypeErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getMedicineTypeByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMedicineTypeByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.medicineTypeInfo = action?.payload?.result?.list;
      })
      .addCase(getMedicineTypeByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchMedicineTypeErrorMessage = action?.payload?.result?.message;
      })
  },
});

export const {
  resetSearchMedicineTypeMessage,
} = medicineTypeSlice.actions;

export default medicineTypeSlice.reducer;
